import { checkboxComponentProps } from '../../utils/component';
import { CheckboxProps } from './checkbox.types';

export const checkboxProps = (props: CheckboxProps): string => {
  const { color = 'primary' } = props;

  const defaultProps =
    checkboxComponentProps[color] ?? checkboxComponentProps['primary'];

  return `${defaultProps}`;
};
